/**
 * Shared day-part windows (local time) — reuse anywhere that needs morning/afternoon slots.
 * - morning: 01:00 – 13:00
 * - afternoon: 13:00 – 01:00 next day
 */

export type DayPartWindow = 'morning' | 'afternoon';

/** Which half-day window `now` falls into. */
export const getDayPartWindow = (now: Date = new Date()): DayPartWindow => {
  const hour = now.getHours();
  if (hour >= 1 && hour < 13) return 'morning';
  return 'afternoon';
};

/**
 * Date stamp for the active window.
 * Afternoon 00:00–01:00 rolls back one calendar day so it stays on the same afternoon slot.
 */
export const getDayPartWindowDateKey = (now: Date = new Date()): string => {
  const window = getDayPartWindow(now);
  const d = new Date(now);
  if (window === 'afternoon' && d.getHours() < 1) {
    d.setDate(d.getDate() - 1);
  }
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

/** Combined key, e.g. `2026-08-07:morning` — handy for storage / dedupe. */
export const getDayPartWindowId = (now: Date = new Date()): string =>
  `${getDayPartWindowDateKey(now)}:${getDayPartWindow(now)}`;
